import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
    MdClose,
    MdOpenInFull,
    MdCloseFullscreen,
    MdExitToApp,
    MdKeyboardArrowDown,
    MdKeyboardArrowUp,
    MdOutlineBookmark,
    MdOutlineBookmarkBorder,
    MdOutlineCalculate,
    MdOutlineKeyboard,
    MdOutlineLocationOn,
    // MdOutlinePlayCircle,
    MdSuperscript
} from 'react-icons/md';
import { IoMdRadioButtonOn, IoMdRadioButtonOff } from "react-icons/io";
import { IoMenu } from 'react-icons/io5';
import { RiStopCircleLine, RiFilter2Line } from "react-icons/ri";
import { FaBookmark, FaRegBookmark } from "react-icons/fa";
import moment from 'moment';
// import Player from '@vimeo/player';
import Button from 'components/Button';
import TextInput from 'components/TextInput';
import Loader from 'components/Loader';
// import Popup from 'components/Popup';
import axios from 'config/axios';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { setError } from 'store/error';
import { MULTIPLE_CHOICES } from 'global/constants';
import { getDeviceOS } from 'global/os';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';
import './index.css';

import 'katex/dist/katex.min.css';
import renderMathInElement from "katex/dist/contrib/auto-render.js";
import { flattenKatexUnderlines } from 'global/katexWrap';

function DigitalACTReview() {
    const [studentName, setStudentName] = useState('');
    const [testName, setTestName] = useState('');
    const [testModules, setTestModules] = useState(null);
    const [moduleIndex, setModuleIndex] = useState(0);
    const [questionIndex, setQuestionIndex] = useState(0);
    const [moduleSelectOpen, setModuleSelectOpen] = useState(false);
    const [directionsOpen, setDirectionsOpen] = useState(false);
    const [navigatorOpen, setNavigatorOpen] = useState(false);
    const [indexOpen, setIndexOpen] = useState(true);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [indexFilter, setIndexFilter] = useState<{[key: string]: number}>({'All questions': 0, 'Correct': 0, 'Incorrect': 0, 'Flagged': 0});
    const [indexFilterSelected, setIndexFilterSelected] = useState('All questions');
    const [filteredQuestions, setFilteredQuestions] = useState([]);
    const [calculator, setCalculator] = useState(null);
    const [calculatorOpen, setCalculatorOpen] = useState(false);
    const [calculatorFull, setCalculatorFull] = useState(false);
    const [showAnswer, setShowAnswer] = useState(false);
    const [explanationOpen, setExplanationOpen] = useState(false);
    const [annotations, setAnnotations] = useState([]);
    const [fullPassage, setFullPassage] = useState<{
        html?: string;
        preview?: string;
    } | null>(null);
    const [highlighting, setHighlighting] = useState<Array<{
        passageId?: string;
        html?: string;
        preview?: string;
    }>>([]);
    // const [player, setPlayer] = useState(null);
    // const [explanationVideo, setExplanationVideo] = useState(null);

    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    // Use default organization for client site
    const organization = { name: 'The SAT Crash Course', alias: '', customizations: [] };
    const { testId } = useParams();
    const moduleSelectRef = useOutsideClickHandler(() => setTimeout(() => setModuleSelectOpen(false), 10));
    const directionsRef = useOutsideClickHandler(() => setTimeout(() => setDirectionsOpen(false), 10));
    const passageContainerRef = useRef(null);
    const navigatorRef = useOutsideClickHandler(() => setTimeout(() => setNavigatorOpen(false), 10));
    const indexContainerRef = useRef(null);
    const questionRefs = useRef([]);
    // const explanationRef = useOutsideClickHandler(() => setExplanationVideo(null));

    const prevQuestion = () => {
        if (questionIndex > 0) {
            setQuestionIndex(questionIndex - 1);
        }  
        else if (moduleIndex > 0) {
            setQuestionIndex(testModules[moduleIndex - 1].questions.length - 1);
            setModuleIndex(moduleIndex - 1);
        }
    }

    const nextQuestion = () => {
        if (questionIndex < testModules[moduleIndex].questions.length - 1) {
            setQuestionIndex(questionIndex + 1);
        }
        else if (moduleIndex < testModules.length - 1) {
            setModuleIndex(moduleIndex + 1);
            setQuestionIndex(0);
        }
        else {
            // exit the review
            navigate(-1);
        }
    }

    const goToQuestion = (index: number) => {
        setQuestionIndex(index);

        let passages = document.getElementById('digitalACTReview__passages');
        let question = document.getElementById('digitalACTReview__questionChoices');

        if (passages) passages.scrollTop = 0;
        if (question) question.scrollTop = 0;
    }

    const formatTime = (time: number) => {
        const duration = moment.duration(time, 'seconds');

        const hours = duration.hours();
        const minutes = (hours && duration.minutes() < 10) ? `0${duration.minutes()}` : duration.minutes();
        const seconds = duration.seconds() < 10 ? `0${duration.seconds()}` : duration.seconds();

        return hours ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`;
    }

    const generateHightlightIndexing = ({id: passageId, indices, passageFigures = []}) => {
        for (let j = 0; j < indices.length; j++){
            const passage = document.getElementById(passageId);
            let passageHTML = '';
            let passagePreview = '';
            const usedFigureIndices = new Set();
            const { startIndex, endIndex } = indices[j];
            let startOffset = startIndex
            let endOffset = endIndex
            let lastIndex = 0;

            for (let i = 0; i < passage.childNodes.length; i++) {
                const childNode = passage.childNodes[i];

                const addMarkTags = (node) => {
                    if (node.outerHTML) {
                        const { innerHTML, outerHTML } = node;
                        const childOffset = outerHTML.indexOf('>') + 1;
    
                        passageHTML += outerHTML.slice(0, childOffset);
    
                        for (let i = 0; i < node.childNodes.length; i++) {
                            const child = node.childNodes[i];
                            addMarkTags(child);
                        }
    
                        passageHTML += outerHTML.slice(childOffset + innerHTML.length);
                    }
                    else {
                        // 이미지 삽입을 위한 passageFigure 검사
                        const currentFigure = passageFigures.find(fig => fig.index === lastIndex && !usedFigureIndices.has(fig.index));
                        if (currentFigure) {
                            usedFigureIndices.add(currentFigure.figure.index);
                            // passageHTML += `
                            //     <div style="width:100%; overflow:hidden; margin:10px 0;"><img src="${currentFigure.figure.image}" alt="figure" style="width:100%; height:100%; object-fit:contain;" /></div>
                            // `;   
                            passageHTML += `
                                <img src="${currentFigure.figure.image}" alt="figure" style="width: auto; height: auto; max-width:100%; margin: 10px 0;" /></br>
                            `;      
                        }
                        const { textContent } = node;
    
                        if (startOffset >= lastIndex && endOffset <= lastIndex + textContent.length) {
                            passageHTML += textContent.slice(0, startOffset - lastIndex);
                            passageHTML += '<mark>';
                            passageHTML += textContent.slice(startOffset - lastIndex, endOffset - lastIndex);
                            passageHTML += '</mark>';
                            passageHTML += textContent.slice(endOffset - lastIndex, textContent.length);
                            passagePreview += textContent.slice(startOffset - lastIndex, endOffset - lastIndex);
                        }
                        else if (startOffset >= lastIndex && startOffset < lastIndex + textContent.length) {
                            passageHTML += textContent.slice(0, startOffset - lastIndex);
                            passageHTML += '<mark>';
                            passageHTML += textContent.slice(startOffset - lastIndex, textContent.length);
                            passageHTML += '</mark>';
                            passagePreview += textContent.slice(startOffset - lastIndex, textContent.length);
                        }
                        else if (endOffset >= lastIndex && endOffset < lastIndex + textContent.length) {
                            passageHTML += '<mark>';
                            passageHTML += textContent.slice(0, endOffset - lastIndex);
                            passageHTML += '</mark>';
                            passageHTML += textContent.slice(endOffset - lastIndex, textContent.length);
                            passagePreview += textContent.slice(0, endOffset - lastIndex);
                        }
                        else if (startOffset <= lastIndex && endOffset >= lastIndex + textContent.length) {
                            passageHTML += '<mark>';
                            passageHTML += textContent;
                            passageHTML += '</mark>';
                            passagePreview += textContent;
                        }
                        else {
                            passageHTML += textContent;
                        }
    
                        lastIndex += textContent.length;
                    }
                }
    
                addMarkTags(childNode);
            }

            const currentFigure = passageFigures.find(fig => fig.index === lastIndex && !usedFigureIndices.has(fig.index));
            if (currentFigure) {
                // passageHTML += `
                //     <div style="width:100%; overflow:hidden; margin:10px 0;"><img src="${currentFigure.figure.image}" alt="figure" style="width:100%; height:100%; object-fit:contain;" /></div>
                // `;    
                passageHTML += `
                    <img src="${currentFigure.figure.image}" alt="figure" style="width: auto; height: auto; max-width:100%; margin: 10px 0;" /></br>
                `;                
            }

            setHighlighting(prev => [...(prev || []), { 
                passageId: passageId,
                html: passageHTML, 
                preview: passagePreview 
            }]);
        }

    };

    const getPassageWithFigure = ({id: passageId, passageFigures = []}) => {
        const passage = document.getElementById(passageId);
        let passageHTML = '';
        let lastIndex = 0;
        const usedFigureIndices = new Set();

        for (let i = 0; i < passage.childNodes.length; i++) {
            const childNode = passage.childNodes[i];
            // add open tags first while see the text
            const addMarkTags = (node) => {
                if (node.outerHTML) {
                    const { innerHTML, outerHTML } = node;
                    const childOffset = outerHTML.indexOf('>') + 1;

                    passageHTML += outerHTML.slice(0, childOffset);

                    for (let i = 0; i < node.childNodes.length; i++) {
                        const child = node.childNodes[i];
                        addMarkTags(child);
                    }

                    passageHTML += outerHTML.slice(childOffset + innerHTML.length);
                } 
                else {
                    // 이미지 삽입을 위한 passageFigure 검사
                    const currentFigure = passageFigures.find(fig => fig.index === lastIndex && !usedFigureIndices.has(fig.index));
                    if (currentFigure) {
                        usedFigureIndices.add(currentFigure.figure.index);
                        // passageHTML += `
                        //     <div style="width:100%; overflow:hidden; margin:10px 0;"><img src="${currentFigure.figure.image}" alt="figure" style="width:100%; height:100%; object-fit:contain;" /></div>
                        // `;        
                        passageHTML += `
                            <img src="${currentFigure.figure.image}" alt="figure" style="width: auto; height: auto; max-width:100%; margin: 10px 0;" /></br>
                        `;            
                    }
                    const { textContent } = node;
                    passageHTML += textContent;
                    lastIndex += textContent.length;
                }  
            }

            addMarkTags(childNode);
        }

        const currentFigure = passageFigures.find(fig => fig.index === lastIndex && !usedFigureIndices.has(fig.index));
        if (currentFigure) {
            // passageHTML += `
            //     <div style="width:100%; overflow:hidden; margin:10px 0;"><img src="${currentFigure.figure.image}" alt="figure" style="width:100%; height:100%; object-fit:contain;" /></div>
            // `;   
            passageHTML += `
                <img src="${currentFigure.figure.image}" alt="figure" style="width: auto; height: auto; max-width:100%; margin: 10px 0;" /></br>
            `;                 
        }

        setFullPassage({
            html: passageHTML
        });

    };

    const generateAnnotation = () => {
        const newAnnotations = [ ...testModules[moduleIndex].answers[questionIndex].annotations ];

        for (let i = 0; i < newAnnotations.length; i++) {
            const {
                passageId,
                startIndex,
                endIndex
            } = newAnnotations[i];

            const passage = document.getElementById(`passage ${passageId}`);
            if (!passage) {
                return;
            }

            let passageHTML = '';
            let passagePreview = '';
            let lastIndex = 0;
            for (let i = 0; i < passage.childNodes.length; i++) {
                const childNode = passage.childNodes[i];
    
                const addMarkTags = (node) => {
                    if (node.nodeName === 'IMG') {
                        passageHTML += node.outerHTML;
                    }
                    else if (node.outerHTML) {
                        const { innerHTML, outerHTML } = node;
                        const childOffset = outerHTML.indexOf('>') + 1;
    
                        passageHTML += outerHTML.slice(0, childOffset);
    
                        for (let i = 0; i < node.childNodes.length; i++) {
                            const child = node.childNodes[i];
                            addMarkTags(child);
                        }
    
                        passageHTML += outerHTML.slice(childOffset + innerHTML.length);
                    }
                    else {
                        const { textContent } = node;
    
                        if (startIndex >= lastIndex && endIndex <= lastIndex + textContent.length) {
                            passageHTML += textContent.slice(0, startIndex - lastIndex);
                            passageHTML += '<mark>';
                            passageHTML += textContent.slice(startIndex - lastIndex, endIndex - lastIndex);
                            passageHTML += '</mark>';
                            passageHTML += textContent.slice(endIndex - lastIndex, textContent.length);
                            passagePreview += textContent.slice(startIndex - lastIndex, endIndex - lastIndex);
                        }
                        else if (startIndex >= lastIndex && startIndex < lastIndex + textContent.length) {
                            passageHTML += textContent.slice(0, startIndex - lastIndex);
                            passageHTML += '<mark>';
                            passageHTML += textContent.slice(startIndex - lastIndex, textContent.length);
                            passageHTML += '</mark>';
                            passagePreview += textContent.slice(startIndex - lastIndex, textContent.length);
                        }
                        else if (endIndex >= lastIndex && endIndex < lastIndex + textContent.length) {
                            passageHTML += '<mark>';
                            passageHTML += textContent.slice(0, endIndex - lastIndex);
                            passageHTML += '</mark>';
                            passageHTML += textContent.slice(endIndex - lastIndex, textContent.length);
                            passagePreview += textContent.slice(0, endIndex - lastIndex);
                        }
                        else if (startIndex <= lastIndex && endIndex >= lastIndex + textContent.length) {
                            passageHTML += '<mark>';
                            passageHTML += textContent;
                            passageHTML += '</mark>';
                            passagePreview += textContent;
                        }
                        else {
                            passageHTML += textContent;
                        }
    
                        lastIndex += textContent.length;
                    }
                }
    
                addMarkTags(childNode);
            }

            newAnnotations[i].html = passageHTML;
            newAnnotations[i].preview = passagePreview;
        }

        setAnnotations(newAnnotations);
    }

    const renderKatex = () => {
        const katex = document.getElementsByClassName('katex');
        for (let i = 0; i < katex.length; i++) {
            renderMathInElement(katex[i], {
                delimiters: [
                    {left: '$$', right: '$$', display: true},
                    {left: '$', right: '$', display: false},
                    {left: '\\(', right: '\\)', display: false},
                    {left: '\\[', right: '\\]', display: true}
                ],
                trust: true
            });

            katex[i].innerHTML = katex[i].innerHTML.replaceAll('&nbsp;', ' ');
        }

        const wrappingTexts = document.querySelectorAll<HTMLElement>('.katex-html .base');
        for (let i = 0; i < wrappingTexts.length; i++) {
            // console.log(wrappingTexts[i]);
            if (testModules[moduleIndex].subject === 'ACT Reading' || testModules[moduleIndex].subject === 'ACT English'|| testModules[moduleIndex].subject === 'ACT Science') {
                wrappingTexts[i].classList.add('wrap');
            }
            else {
                wrappingTexts[i].classList.remove('wrap');
            }
        }

        flattenKatexUnderlines(document);

        const math = document.querySelectorAll('.katex-mathml');
        for (let i = 0; i < math.length; i++) {
            math[i].remove();
        }
    }

    const dragMove = (element: HTMLElement, header: HTMLElement) => {
        header.style.cursor = 'grab';
        let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    
        const dragMouseDown = (event) => {
            event.preventDefault();
    
            if (event.type === 'mousedown') {
                pos3 = event.clientX;
                pos4 = event.clientY;
                document.onmousemove = dragElement;
                document.onmouseup = closeDragElement;
            } else if (event.type === 'touchstart') {
                pos3 = event.touches[0].clientX;
                pos4 = event.touches[0].clientY;
                document.ontouchmove = dragElement;
                document.ontouchend = closeDragElement;
            }
        };
    
        const dragElement = (event) => {
            event.preventDefault();
    
            if (event.type === 'mousemove') {
                pos1 = pos3 - event.clientX;
                pos2 = pos4 - event.clientY;
                pos3 = event.clientX;
                pos4 = event.clientY;
            } else if (event.type === 'touchmove') {
                pos1 = pos3 - event.touches[0].clientX;
                pos2 = pos4 - event.touches[0].clientY;
                pos3 = event.touches[0].clientX;
                pos4 = event.touches[0].clientY;
            }
    
            if (pos3 > 0 && pos4 > 0 && pos3 < window.innerWidth && pos4 < window.innerHeight) {
                element.style.top = (element.offsetTop - pos2) + 'px';
                element.style.left = (element.offsetLeft - pos1) + 'px';
            }
            else {
                document.onmouseup(event);
                closeDragElement();
            }
        };
    
        const closeDragElement = () => {
            document.onmouseup = null;
            document.onmousemove = null;
            document.ontouchend = null;
            document.ontouchmove = null;
        };
    
        header.onmousedown = (event) => {
            if (event.target instanceof Element && (event.target.closest('.digitalACTReview__popupHeaderIcon') || event.target.closest('.digitalACTReview__popupHeaderFull'))) {
                return;
            }
            dragMouseDown(event);
        };
    
        header.ontouchstart = (event) => {
            if (event.target instanceof Element && (event.target.closest('.digitalACTReview__popupHeaderIcon') || event.target.closest('.digitalACTReview__popupHeaderFull'))) {
                return;
            }
            dragMouseDown(event);
        };
    };

    useEffect(() => {
        axios.get(`tests/digital/act/review/${testId}/`)
            .then(res => {
                setStudentName(res.data.studentName);
                setTestName(res.data.name || 'ACT Practice Test');
                setTestModules(res.data.testModules);
            })
            .catch(error => {
                // console.log(error);
                dispatch(setError(error));
            });
    }, []);

    // passage scroll, passage magnifier scroll (according to the highliting index)
    useLayoutEffect(() => {
        if (highlighting.length > 0) {
            const passageId = highlighting[0].passageId;
            const passage = document.getElementById(`highlighting ${passageId}`);
            // highlighting 여러개일 경우 첫 번째 
            if (passage) {
                let firstHighlight = passage.querySelector("mark"); // 첫 번째 mark 태그 찾기
                let offset = 0;
                while (firstHighlight !== passage) {
                    offset = firstHighlight.offsetTop;
                    firstHighlight = firstHighlight.parentElement;
                }
                if (firstHighlight && passageContainerRef.current) {
                    passageContainerRef.current.scrollTo({
                        top: firstHighlight? offset - passageContainerRef.current.offsetTop: 0,
                        behavior: "smooth", 
                    });
                }
            }
        }
    }, [highlighting]);

    useEffect(() => {
        if (testModules) {
            let calculatorEl = document.getElementById('calculator');
            setCalculator(Desmos.GraphingCalculator(calculatorEl, {
                notes: false,
                folders: false,
                images: false,
                links: false
            }));

            // dragMove(document.getElementById('calculatorDrag'), document.getElementById('calculatorHeader'));
            const calculatorDragEl = document.getElementById('calculatorDrag');
            const calculatorHeaderEl = document.getElementById('calculatorHeader');
            if (calculatorDragEl && calculatorHeaderEl) {
                dragMove(calculatorDragEl, calculatorHeaderEl);
            }

            const explanationDragEl = document.getElementById('explanationDrag');
            const explanationHeaderEl = document.getElementById('explanationHeader');
            if (explanationDragEl && explanationHeaderEl) {
                dragMove(explanationDragEl, explanationHeaderEl);
            }
        }
    }, [testModules]);

    useLayoutEffect(() => {
        if (testModules) {
            renderKatex();
            generateAnnotation();
            setHighlighting([]);
            setFullPassage(null);
            const passageData = testModules[moduleIndex].questions[questionIndex]?.passages;
            if (passageData) {
                const { id, indices, passageFigures } = testModules[moduleIndex].questions[questionIndex].passages
                if (indices) generateHightlightIndexing({ id, indices, passageFigures });  
                getPassageWithFigure({ id, passageFigures });
            }
        }
    }, [testModules, moduleIndex, questionIndex]);

    useEffect(() => {
        if (testModules) {
            renderKatex();
        }
    }, [directionsOpen, explanationOpen]);
    
    useEffect(() => {
        if (fullPassage) {
            generateAnnotation();
        }
    }, [fullPassage]);
    
    // useEffect(() => {
    //     if (testModules) {
    //         // renderKatex();
    //     }
    // }, [questionIndex, testModules, fullPassage, highlighting]);

    useEffect(() => {
        if (calculatorOpen) {
            calculator.focusFirstExpression();
        }
    }, [calculatorOpen]);

    // Index filtering
    useEffect(() => {
        if (testModules) {
            const questions = testModules[moduleIndex].questions;
            const answers = testModules[moduleIndex].answers;
            
            switch(indexFilterSelected) {
                case 'All questions':
                    setFilteredQuestions(questions);
                    break;
                case 'Correct':
                    setFilteredQuestions(questions.filter((q, i) => answers[i].isCorrect));
                    break;
                case 'Incorrect':
                    setFilteredQuestions(questions.filter((q, i) => !answers[i].isCorrect));
                    break;
                case 'Flagged':
                    setFilteredQuestions(questions.filter((q, i) => answers[i].marked));
                    break;
            }
        }
    }, [indexFilterSelected, testModules, moduleIndex]);

    // Update filter counts
    useEffect(() => {
        if (testModules) {
            const questions = testModules[moduleIndex].questions;
            const answers = testModules[moduleIndex].answers;
            
            setIndexFilter({
                'All questions': questions.length,
                'Correct': answers.filter(a => a.isCorrect).length,
                'Incorrect': answers.filter(a => !a.isCorrect).length,
                'Flagged': answers.filter(a => a.marked).length
            });
        }
    }, [testModules, moduleIndex]);

    // Render KaTeX when filtered questions change (for index panel)
    useEffect(() => {
        if (filteredQuestions.length > 0) {
            renderKatex();
        }
    }, [filteredQuestions]);

    // Scroll to current question in index
    useEffect(() => {
        if (questionIndex >= 0 && questionRefs.current[questionIndex] && indexOpen) {
            if (indexContainerRef.current) {
                const scrollTopValue = questionRefs.current[questionIndex].offsetTop - indexContainerRef.current.offsetTop;
                indexContainerRef.current.scrollTo({
                    top: scrollTopValue,
                    behavior: "smooth"
                });
            }
        } 
    }, [questionIndex, indexOpen, filteredQuestions]);

    if (testModules === null) return <Loader />;

    const {
        name,
        questions,
        answers,
        subject,
        prompt
    } = testModules[moduleIndex];

    return (
        <div className='digitalACTReview' onCopy={(event) => { event.preventDefault() }}>
            <Helmet>
                <title>
                    Reviewing {name} - {organization.name}
                </title>
            </Helmet>
            
            {/* ACT-style Header */}
            <div className='digitalACTReview__header'>
                {/* header - left */}
                <div className='digitalACTReview__title'>
                    <div className='digitalACTReview__titleContent'>
                        {testName || 'Digital ACT Practice Test'}
                    </div>
                </div>
                
                {/* header - middle: Module Select */}
                <div className='digitalACTReview__moduleSelectGroup'>
                    <button className='digitalACTReview__moduleSelect' onClick={() => setModuleSelectOpen(!moduleSelectOpen)}>
                        <span className='digitalACTReview__moduleSelectText'>
                            {subject.replace('ACT ', '')}
                        </span>
                        {moduleSelectOpen
                            ? <MdKeyboardArrowUp className='digitalACTReview__moduleSelectIcon' />
                            : <MdKeyboardArrowDown className='digitalACTReview__moduleSelectIcon' />
                        }
                    </button>
                    {moduleSelectOpen &&
                        <div className='digitalACTReview__moduleSelectDropdown' ref={moduleSelectRef}>
                            {testModules.map((testModule, t) => (
                                <p
                                    key={testModule.subject}
                                    className={t === moduleIndex
                                        ? 'digitalACTReview__moduleSelectDropdownItem--selected'
                                        : 'digitalACTReview__moduleSelectDropdownItem'
                                    }
                                    onClick={() => {
                                        if (t !== moduleIndex) {
                                            setModuleIndex(t);
                                            setQuestionIndex(0);
                                        }
                                        setModuleSelectOpen(false);
                                    }}
                                >
                                    {testModule.subject.replace('ACT ', '')}
                                </p>
                            ))}
                        </div>
                    }
                </div>
                
                {/* header - right */}
                <div className='digitalACTReview__testInfoGroup'>
                    <div className='digitalACTReview__endTest' onClick={() => navigate(-1)}>
                        <RiStopCircleLine className='digitalACTReview__endTestIcon'/>
                        <div className='digitalACTReview__endTestContent'>EXIT</div>
                    </div>
                </div>
            </div>

            {/* Body */}
            <div className='digitalACTReview__body'>
                <div className='digitalACTReview__bodyMain'>
                    {/* body-testModule */}
                    <div className={indexOpen ? 'digitalACTReview__testModule--open' : 'digitalACTReview__testModule'}>
                        {/* Calculator popup */}
                        <div id='calculatorDrag' className={calculatorOpen
                            ? (calculatorFull
                                ? 'digitalACTReview__popup--calculatorFull'
                                : 'digitalACTReview__popup--calculator'
                              )
                            : 'digitalACTReview__popup--hidden'
                        }>
                            <div id='calculatorHeader' className='digitalACTReview__popupHeader'>
                                <h3 className='digitalACTReview__popupHeaderText'>Scientific Calculator</h3>
                                {calculatorFull
                                    ? <MdCloseFullscreen className='digitalACTReview__popupHeaderFull' onClick={() => setCalculatorFull(false)} />
                                    : <MdOpenInFull className='digitalACTReview__popupHeaderFull' onClick={() => setCalculatorFull(true)} />
                                }
                                <MdClose className='digitalACTReview__popupHeaderIcon' onClick={() => setCalculatorOpen(false)} />
                            </div>
                            <div
                                id='calculator'
                                style={{ width: calculatorFull ? 800 : 400, height: 600 }}
                            ></div>
                        </div>

                        {/* Explanation popup */}
                        {(questions[questionIndex].explanation || questions[questionIndex].explanationFigure) &&
                            <div id='explanationDrag' className={explanationOpen
                                ? 'digitalACTReview__popup--explanation'
                                : 'digitalACTReview__popup--hidden'
                            }>
                                <div id='explanationHeader' className='digitalACTReview__popupHeader'>
                                    <h3 className='digitalACTReview__popupHeaderText'>
                                        Explanation
                                    </h3>
                                    <MdClose className='digitalACTReview__popupHeaderIcon' onClick={() => setExplanationOpen(false)} />
                                </div>
                                <div className='digitalACTReview__popupBody'>
                                    {questions[questionIndex].explanationFigure && (
                                        <img 
                                            src={questions[questionIndex].explanationFigure} 
                                            alt="Explanation" 
                                            style={{ maxWidth: '100%', height: 'auto', marginBottom: questions[questionIndex].explanation ? '10px' : '0' }}
                                        />
                                    )}
                                    {questions[questionIndex].explanation && (
                                        <p className='katex digitalACTReview__popupBodyText'>
                                            {questions[questionIndex].explanation}
                                        </p>
                                    )}
                                </div>
                            </div>
                        }

                        {/* body-testModule-header */}
                        <div className='digitalACTReview__testModule__header'>
                            <div className='digitalACTReview__testModule__questionNum'>ITEM # {questionIndex + 1}</div>
                            <div className='digitalACTReview__testModule__headerRight'>
                                {answers[questionIndex].marked && (
                                    <div className='digitalACTReview__testModule__flagContainer'>
                                        <FaBookmark className='digitalACTReview__testModule__flagIcon mark' />
                                        <span className='mark'>FLAG</span>
                                    </div>
                                )}
                                <div className={answers[questionIndex].isCorrect
                                    ? 'digitalACTReview__testModule__status--correct'
                                    : 'digitalACTReview__testModule__status--incorrect'
                                }>
                                    {answers[questionIndex].isCorrect ? 'CORRECT' : 'INCORRECT'}
                                </div>
                            </div>
                        </div>
                        <div className='digitalACTReview__dottedLine' />

                        {/* body-testModule-body */}
                        <div className='digitalACTReview__test'>
                            {questions[questionIndex].passages && <>
                                <div className='digitalACTReview__material' ref={passageContainerRef}>
                                    <div className='digitalACTReview__materialContent'>
                                        <div key={questions[questionIndex].passages.id} className='digitalACTReview__passage'>
                                            <p
                                                id={questions[questionIndex].passages.id}
                                                className='katex digitalACTReview__passageText'
                                            >
                                                {questions[questionIndex].passages.passage}
                                            </p>
                                            <p
                                                id={`passage ${questions[questionIndex].passages.id}`}
                                                className='katex digitalACTReview__passageTextPassage'
                                                dangerouslySetInnerHTML={{ __html: fullPassage?.html }}
                                            >
                                            </p>
                                            {highlighting.length > 0 &&
                                                highlighting.map((highlight, index)=>
                                                    <div
                                                        id={`highlighting ${questions[questionIndex].passages.id}`}
                                                        key={index}
                                                        className='katex digitalACTReview__Highlight'
                                                        dangerouslySetInnerHTML={{ __html: highlight?.html }}
                                                    ></div>
                                                )
                                            }
                                            {
                                                answers[questionIndex].annotations.filter(annotation => (
                                                    annotation.passageId === `${questions[questionIndex].passages.id}`
                                                )).map((annotation, a) => (
                                                    <div
                                                        key={a}
                                                        className='katex digitalACTReview__passageAnnotation'
                                                        dangerouslySetInnerHTML={{ __html: annotation.html }}
                                                    ></div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='digitalACTReview__verticalLine'></div>
                            </>}
                            <div className='digitalACTReview__question'>
                                <div className='digitalACTReview__questionContent'>
                                    <div className='digitalACTReview__questionHeader'>
                                        {(questions[questionIndex].explanation || questions[questionIndex].explanationFigure) &&
                                            <button
                                                className={explanationOpen
                                                    ? 'digitalACTReview__showExplanation--active'
                                                    : 'digitalACTReview__showExplanation'
                                                }
                                                onClick={() => setExplanationOpen(!explanationOpen)}
                                            >
                                                Explanation
                                            </button>
                                        }
                                        <button
                                            className={showAnswer
                                                ? 'digitalACTReview__showAnswer--active'
                                                : 'digitalACTReview__showAnswer'
                                            }
                                            onClick={() => setShowAnswer(!showAnswer)}
                                        >
                                            {showAnswer ? 'Hide answer' : 'Show answer'}
                                        </button>
                                        {subject === 'ACT Mathematics' &&
                                            <button 
                                                className={calculatorOpen
                                                    ? 'digitalACTReview__calculatorButton--active'
                                                    : 'digitalACTReview__calculatorButton'
                                                }
                                                onClick={() => setCalculatorOpen(!calculatorOpen)}
                                            >
                                                <MdOutlineCalculate className='digitalACTReview__calculatorIcon' />
                                                Calculator
                                            </button>
                                        }
                                    </div>
                                    <div id='digitalACTReview__questionChoices' className='digitalACTReview__questionChoices'>
                                        <p className='digitalACTReview__questionQuestionContainer'>
                                            <span className='katex digialACTReview__questionQuestion'>
                                                {questions[questionIndex].question}
                                            </span>
                                            {questions[questionIndex].figures &&
                                                questions[questionIndex].figures.map(figure => (
                                                    <img
                                                        className='digitalACTReview__figure'
                                                        key={figure.id}
                                                        src={figure.image}
                                                        alt={(questionIndex + 1).toString()}
                                                    />
                                                ))
                                            }
                                        </p>
                                        {questions[questionIndex].choices.length
                                        ?   <>
                                                {questions[questionIndex].choices.map((choice, i) => (
                                                    <div key={choice.id} className='digitalACTReview__questionChoiceWrapper'>
                                                        <div className='digitalACTReview__choiceContainer'>
                                                            <div
                                                                className={showAnswer && choice.isCorrect
                                                                    ? 'digitalACTReview__radioButton--correct'
                                                                    : answers[questionIndex].answer == choice.id
                                                                    ? (choice.isCorrect 
                                                                        ? 'digitalACTReview__radioButton--selected'
                                                                        : 'digitalACTReview__radioButton--wrong'
                                                                    )
                                                                    : 'digitalACTReview__radioButton'
                                                            }>
                                                                {showAnswer && choice.isCorrect || answers[questionIndex].answer == choice.id?
                                                                    <IoMdRadioButtonOn className='digitalACTReview__radioButtonIcon'/>
                                                                    : <IoMdRadioButtonOff className='digitalACTReview__radioButtonIcon'/>
                                                                }
                                                            </div>
                                                            <div className={showAnswer && choice.isCorrect
                                                                ? 'digitalACTReview__questionChoiceContent--correct'
                                                                : answers[questionIndex].answer == choice.id
                                                                ? (choice.isCorrect 
                                                                    ? 'digitalACTReview__questionChoiceContent--selected'
                                                                    : 'digitalACTReview__questionChoiceContent--wrong'
                                                                )
                                                                : 'digitalACTReview__questionChoiceContent'
                                                            }>
                                                                <p className={showAnswer && choice.isCorrect
                                                                    ? 'digitalACTReview__choiceText--correct'
                                                                    : answers[questionIndex].answer == choice.id
                                                                    ? (choice.isCorrect 
                                                                        ? 'digitalACTReview__choiceText--selected'
                                                                        : 'digitalACTReview__choiceText--wrong'
                                                                    )
                                                                    : 'digitalACTReview__choiceText'
                                                                }>
                                                                    {MULTIPLE_CHOICES[i]}.
                                                                </p>
                                                                {choice.figure
                                                                ?   <img
                                                                        className='digitalACTReview__questionChoiceFigure'
                                                                        key={choice.figure}
                                                                        src={choice.figure}
                                                                        alt={choice.figure}
                                                                    />
                                                                :   <p className='digitalACTReview__questionChoiceText'>
                                                                        <span className='katex'>
                                                                            {choice.choice}
                                                                        </span>
                                                                    </p>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        :   <div className='digitalACTReview__questionAnswerReview'>
                                                <TextInput
                                                    className='digitalACTReview__questionAnswer'
                                                    inputClassName='digitalACTReview__questionAnswerInput'
                                                    name={name + questionIndex}
                                                    value={answers[questionIndex].answer
                                                        ? answers[questionIndex].answer
                                                        : ''
                                                    }
                                                    onChange={() => {}}
                                                />
                                                {showAnswer &&
                                                    <p className='digitalACTReview__questionCorrectAnswer'>
                                                        {questions[questionIndex].correctAnswers.toString().replaceAll(',', ', ')}
                                                    </p>
                                                }
                                            </div>
                                        }
                                        <div className='digitalACTReview__marginBottom'></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* body-testModule-footer */}
                        <div className='digitalACTReview__dottedLine2' />
                        <div className='digitalACTReview__testModule__footer'>
                            <div className='digitalACTReview__testModule__footerButtons'>
                                <Button
                                    className='digitalACTReview__testModule__Button'
                                    secondary
                                    disabled={moduleIndex === 0 && questionIndex === 0}
                                    onClick={prevQuestion}
                                >
                                    BACK
                                </Button>
                                <Button
                                    className='digitalACTReview__testModule__Button'
                                    onClick={nextQuestion}
                                >
                                    NEXT
                                </Button>
                            </div>
                        </div>
                    </div>

                    {/* body-index */}
                    {indexOpen &&
                        <div className='digitalACTReview__indexContainer'>
                            <div className='digitalACTReview__indexHeader'>
                                <div className='digitalACTReview__indexHeaderContainer'>
                                    <RiFilter2Line className='digitalACTReview__indexHeaderIcon'/>
                                    <div className='digitalACTReview__indexHeaderTitle'>Filter By</div>
                                </div>
                                <div className='digitalACTReview__indexHeaderFilter'>
                                    <div 
                                        className={isFilterOpen ? 'digitalACTReview__filterDropdown--open' : 'digitalACTReview__filterDropdown'}
                                        onClick={() => setIsFilterOpen(!isFilterOpen)}
                                    >
                                        <span>{indexFilterSelected.toUpperCase()}</span>
                                        {isFilterOpen 
                                            ? <MdKeyboardArrowUp className='digitalACTReview__filterDropdownIcon' />
                                            : <MdKeyboardArrowDown className='digitalACTReview__filterDropdownIcon' />
                                        }
                                        {isFilterOpen &&
                                            <div className='digitalACTReview__filterDropdownItems'>
                                                {Object.entries(indexFilter).map(([key, count]) => (
                                                    <div 
                                                        key={key}
                                                        className={indexFilterSelected === key 
                                                            ? 'digitalACTReview__filterDropdownItem--selected' 
                                                            : 'digitalACTReview__filterDropdownItem'
                                                        }
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setIndexFilterSelected(key);
                                                            setIsFilterOpen(false);
                                                        }}
                                                    >
                                                        <span>{key}</span>
                                                        <span className='digitalACTReview__filterDropdownCount'>({count})</span>
                                                    </div>
                                                ))}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div 
                                className='digitalACTReview__indexContentContainer'
                                ref={indexContainerRef}
                            >
                                {filteredQuestions.map((question, i) => {
                                    const originalIndex = questions.findIndex(q => q.id === question.id);
                                    const answer = answers[originalIndex];
                                    return (
                                        <div 
                                            key={question.id}
                                            className='digitalACTReview__indexBox'
                                            ref={(el) => questionRefs.current[originalIndex] = el} 
                                        >
                                            <div className={questionIndex === originalIndex
                                                    ? 'digitalACTReview__indexBoxHeader--current'
                                                    : answer?.isCorrect 
                                                    ? 'digitalACTReview__indexBoxHeader--correct'
                                                    : 'digitalACTReview__indexBoxHeader--incorrect'
                                                }
                                            >
                                                {answer?.marked &&
                                                    <FaBookmark className='mark'/>
                                                }
                                                <div className='digitalACTReview__indexBoxHeaderQuestionNumber'>ITEM {originalIndex + 1}</div>
                                                <div className={answer?.isCorrect 
                                                    ? 'digitalACTReview__indexBoxHeaderStatus--correct'
                                                    : 'digitalACTReview__indexBoxHeaderStatus--incorrect'
                                                }>
                                                    {answer?.isCorrect ? 'CORRECT' : 'INCORRECT'}
                                                </div>
                                            </div>
                                            <div className='digitalACTReview__indexBoxBody' onClick={() => goToQuestion(originalIndex)}>
                                                <div className='digitalACTReview__indexBoxBodyQuestion'>
                                                    <span className='katex'>
                                                        {question.question
                                                            .replaceAll('$\\ \\ \\\\$', '')
                                                            .replaceAll('$\\\\ \\, \\\\ $', '')
                                                            .replaceAll('$\\\\ \\ \\\\$', '')
                                                            .replaceAll('$\\\\$', '')
                                                            .replaceAll('$\\qquad$', '')
                                                            .replaceAll(/\$\$(.*?)\$\$/g, (_, match) => `$${match}$`)
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    }
                </div>

                {/* body-rightBar */}
                <div className='digitalACTReview__rightBar'>
                    <div 
                        className={indexOpen
                            ? 'digitalACTReview__rightBarContainer--selected' 
                            : 'digitalACTReview__rightBarContainer' 
                        }
                        onClick={() => setIndexOpen(!indexOpen)}
                    >
                        <IoMenu className='digitalACTReview__rightBarIcon'/>
                        <div className='digitalACTReview__rightBarTitle'>INDEX</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DigitalACTReview;